import { Injectable } from '@angular/core';
import { LocaleLanguage } from '@app/+authenticated/shared/locale/locale.helper';
import {
  NavatticDemoDialogComponent,
  NavatticDemoDialogData,
} from '@app/+onboarding/components/demo-dialog/navattic-demo-dialog.component';
import { TrackingService } from '@app/services/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalBundle } from '@shiftbase-com/models';

import { SbDialogService } from '../../../../../libs/ui/src';
import { UserGuideType } from '../../../reducers/orm/user-guide';
import { SmbHospitalityOnboardingChecklistStep } from '../../../shared/onboarding/onboarding-checklist.model';
import { OnboardingChecklistService } from '../../../shared/onboarding/onboarding-checklist.service';
import { AbsenceManagementDialogComponent } from '../absence-management/absence-management-dialog.component';
import {
  AbsenceManagementDialogStep,
  OnboardingAbsenceManagementRequest,
} from '../absence-management/absence-management.model';
import { ApiGateway } from './../../../api/ApiGateway.service';
import { AbsenceManagementDialogData } from './../absence-management/absence-management.model';

@Injectable({
  providedIn: 'root',
})
export class AbsenceManagementOnboardingService {
  public constructor(
    private readonly onboardingChecklist: OnboardingChecklistService,
    private readonly dialogService: SbDialogService,
    private readonly translate: TranslateService,
    private readonly api: ApiGateway,
    private readonly trackingService: TrackingService,
  ) {}

  public openDialog(originator = 'onboarding', step?: AbsenceManagementDialogStep) {
    return this.dialogService
      .setSize('xxl')
      .open<AbsenceManagementDialogComponent, AbsenceManagementDialogData>(AbsenceManagementDialogComponent, {
        data: {
          eventData: { originator },
          step,
        },
      }).closed;
  }

  public openDemo() {
    const langDemoMap = {
      [LocaleLanguage.ENGLISH]: 'cm6gnj5va000003kv6pq02emq',
      [LocaleLanguage.DUTCH]: 'cm6go2w8w000403l10iwo58ys',
      [LocaleLanguage.GERMAN]: 'cm6gnm1f5000f03ii3rc1dtez',
    };

    const demoId = langDemoMap[this.translate.currentLang] || langDemoMap['en-GB'];

    return this.dialogService
      .setSize('fullscreen')
      .open<NavatticDemoDialogComponent, NavatticDemoDialogData>(NavatticDemoDialogComponent, {
        data: { demoId },
      }).closed;
  }

  public savePreferences(payload: OnboardingAbsenceManagementRequest) {
    return this.api.post('onboarding/absence_management', payload);
  }

  public completeChapter(eventData: ModalBundle) {
    this.trackingService.event('Onboarding Absence Management Completed', eventData);

    return this.onboardingChecklist.completeStep(
      UserGuideType.SELF_ONBOARDING_CHECKLIST,
      SmbHospitalityOnboardingChecklistStep.ABSENCE_MANAGEMENT,
    );
  }
}
